export class OpportunityPropertiesNotInterested {
    constructor(
        public OpportunityId: number = 0,
        public PropertyId: number = 0
    ) { }
}